var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyRoundedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F3F3F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5156_31640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 23.3333H10V12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10H21.3333C21.8638 10 22.3725 10.2107 22.7475 10.5858C23.1226 10.9609 23.3333 11.4696 23.3333 12V23.3333ZM11.3333 22H22V12C22 11.8232 21.9298 11.6536 21.8047 11.5286C21.6797 11.4036 21.5101 11.3333 21.3333 11.3333H12C11.8232 11.3333 11.6536 11.4036 11.5286 11.5286C11.4036 11.6536 11.3333 11.8232 11.3333 12V22ZM24.6667 12.7893V24.6667H12.6667V26H26V14.6667C25.9983 14.2545 25.8693 13.8529 25.6306 13.5169C25.3919 13.1808 25.0553 12.9267 24.6667 12.7893Z",
    fill: "#6A7178"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5156_31640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRoundedIcon);
export default __webpack_public_path__ + "static/media/CopyRoundedIcon.b3df02732133a9245515e76edf8f555c.svg";
export { ForwardRef as ReactComponent };